var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitsIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 53,
    viewBox: "0 0 68 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C49.1046 24 50 23.1046 50 22C50 20.8954 49.1046 20 48 20C46.8954 20 46 20.8954 46 22C46 23.1046 46.8954 24 48 24Z",
    fill: "#FF7403"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7097 11.0417H41.6775",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2258 2.20825H39.4839",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1936 30.9167C2.1936 27.2592 5.14118 24.2917 8.77425 24.2917",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4158 17.6666H61.4193C63.8432 17.6666 65.8064 19.643 65.8064 22.0833V30.9166C65.8064 33.3568 63.8432 35.3333 61.4193 35.3333H59.2258L54.2629 49.3258C53.9503 50.2064 53.1222 50.7916 52.1955 50.7916H48.7077C47.781 50.7916 46.9529 50.2064 46.6403 49.3258L45.5956 46.3749H26.7914L25.7468 49.3258C25.4342 50.2064 24.6061 50.7916 23.6793 50.7916H20.1916C19.2648 50.7916 18.4368 50.2064 18.1242 49.3258L14.5322 39.1978C10.8224 35.1317 8.7687 29.8124 8.77418 24.2916C8.77418 12.0961 18.5958 2.20825 30.7097 2.20825H39.4839C48.2334 2.20825 56.1466 7.43648 59.6206 15.519C59.9222 16.2201 60.1855 16.9378 60.4158 17.6666Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsIcon4);
export default __webpack_public_path__ + "static/media/benefits_icon4.d2e1fde85c0dc4fbfb9d169ab0ccf488.svg";
export { ForwardRef as ReactComponent };